import { Controller, useFormContext } from "react-hook-form";
import styles from "./DefaultDateField.module.scss";
import { classNames } from "primereact/utils";
import { RenderWhen } from "../../../../infrastructure/components/RenderWhen";
import { Calendar } from "primereact/calendar";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Icon, IconType } from "../../../../icons/Icon";
import { useAppContext } from "../../../../../AppContext";

import { dvSize } from "../../../../infrastructure/utilities/viewportUnitsUtility";
interface IDefaultDateFieldProps {
  className?: string;
  name: string;
  placeholder?: string;
  label?: string;
  required?: boolean;
  width?: string;
  disabled?: boolean;
  dateFormat?: string;
  timeOnly?: boolean;
  showTime?: boolean;
}

export const DefaultDateField = ({
  className,
  name,
  placeholder,
  label,
  required = false,
  width,
  disabled,
  dateFormat = "dd/mm/yy",
  timeOnly,
  showTime,
}: IDefaultDateFieldProps) => {
  const { control } = useFormContext();
  const { isDesktopOrTablet } = useAppContext();

  if (!width) {
    if (isDesktopOrTablet) {
      width = "600px";
    } else {
      width = dvSize("80dvw");
    }
  }
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        return (
          <div
            style={{ width: width }}
            className={classNames(className, styles.root, {
              [styles.root_disabled]: disabled,
            })}
          >
            <RenderWhen condition={!!label}>
              <div
                className={classNames(styles.root_label, {
                  [styles.root_label_interacted_with]:
                    !!field.value || fieldState.isTouched,
                  [styles.root_label_error]: !!fieldState.error?.message,
                })}
              >
                {label}
                {required ? "*" : ""}
              </div>
            </RenderWhen>
            <div className={styles.root_input_container}>
              <Calendar
                id={field.name}
                value={field.value}
                onChange={(e) => field.onChange(e.value)}
                dateFormat={dateFormat}
                showIcon
                placeholder={placeholder}
                className={styles.root_input}
                disabled={disabled}
                icon={<Icon type={IconType.ClockIcon} color="currentColor" />}
                timeOnly={timeOnly}
                showTime={showTime}
                stepMinute={5}
                hourFormat="24"
                touchUI
              />
            </div>
          </div>
        );
      }}
    />
  );
};
